import { ShieldCheck, Ruler, Landmark, Users } from "lucide-react";
import Reveal from "./Reveal";

const POINTS = [
  {
    icon: Landmark,
    title: "21 let ve stavebnictví",
    text: "Rekonstrukce a stavby jsou můj denní chléb — od první skici po poslední spáru.",
  },
  {
    icon: Ruler,
    title: "Preciznost bez kompromisů",
    text: "Dávám si záležet na každém detailu a totéž vyžaduji od každého, kdo se mnou spolupracuje.",
  },
  {
    icon: ShieldCheck,
    title: "Evropské normy jako standard",
    text: "Ke každé zakázce přistupuji individuálně a vše stavím podle evropských norem — pro mě to je samozřejmost, ne výhoda.",
  },
  {
    icon: Users,
    title: "Malá aliance, velká kvalita",
    text: "Proto nás není hodně. Každý člen RESTART PRO je prověřený profesionál, za kterého ručím vlastním jménem.",
  },
];

export default function Founder() {
  return (
    <section id="zakladatel" data-testid="founder-section" className="py-24 lg:py-32 bg-coal/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 grid lg:grid-cols-2 gap-16 items-start">
        <Reveal>
          <p className="text-xs font-mono tracking-[0.3em] uppercase text-gold/70 mb-4">
            Zakladatel
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-zinc-100 leading-tight">
            Petr Lehnert — <span className="gold-text">zakladatel v montérkách</span>
          </h2>
          <p className="mt-6 text-zinc-400 leading-relaxed">
            Za 21 let ve stavebnictví jsem si prošel vším. Nečekejte manažera v obleku — na
            vaší stavbě mě potkáte v montérkách s nářadím v ruce, jak makám přímo po boku své
            party. Jsem všestranný řemeslník, ale mou největší vášní jsou precizní sádrokartony
            a zateplovací systémy. Miluji moderní design a složité výzvy — čím komplikovanější
            detail, tím větší důraz kladu na jeho dokonalé provedení. A protože nesnáším
            plýtvání, vyvinul jsem vlastní aplikaci KABUM PRO, díky které klientům počítám
            materiál na milimetry přesně.
          </p>
          <p className="mt-5 text-lg text-zinc-100 font-medium border-l-2 border-gold pl-4">
            Stavím tak, jako bych stavěl pro sebe. A za výsledek ručím zárukou 60 měsíců.
          </p>
          <div
            className="mt-8 inline-flex items-center gap-4 border border-gold/30 bg-gold/5 rounded-xl px-6 py-4"
            data-testid="founder-badge"
          >
            <p className="font-sans font-bold text-4xl gold-text leading-none">60</p>
            <p className="text-xs uppercase tracking-[0.2em] text-zinc-400">
              měsíců záruka
              <span className="block text-[10px] text-zinc-600 mt-0.5">na všechny naše práce</span>
            </p>
          </div>
          <Reveal delay={0.1}>
            <div className="mt-10 group relative overflow-hidden rounded-xl border border-gold/30 max-w-sm" data-testid="founder-photo">
              <img
                src="/assets/gallery/founder-2.webp"
                alt="Petr Lehnert při práci na zateplení fasády"
                loading="lazy"
                className="w-full h-80 sm:h-96 object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <span className="text-[10px] font-mono tracking-[0.2em] uppercase text-gold">
                  Při práci
                </span>
                <p className="text-sm text-zinc-100 font-semibold mt-0.5">Zateplení fasády — detail u okna</p>
              </div>
            </div>
          </Reveal>
        </Reveal>

        <div className="grid sm:grid-cols-2 gap-5">
          {POINTS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.07} className="h-full">
              <div
                className="group h-full bg-card2 border border-white/5 hover:border-gold/30 rounded-xl p-6 transition-colors duration-500"
                data-testid={`founder-point-${i}`}
              >
                <span className="w-11 h-11 rounded-lg bg-gold/10 border border-gold/25 flex items-center justify-center text-gold group-hover:bg-gold group-hover:text-black transition-colors duration-300">
                  <p.icon size={18} />
                </span>
                <h3 className="mt-4 text-zinc-100 font-semibold">{p.title}</h3>
                <p className="text-sm text-zinc-400 leading-relaxed mt-2">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
